import { render, staticRenderFns } from "./QuotationFavoriteCompanyTable.vue?vue&type=template&id=3a6a9304"
import script from "./QuotationFavoriteCompanyTable.vue?vue&type=script&lang=js"
export * from "./QuotationFavoriteCompanyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports